import { styled as o, Box as l, Button as E, Typography as A } from "@mui/material";
import S from "../../temp-lib/assets/icons/icon-cross.svg.js";
import D from "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import G from "../../temp-lib/components/share/generic/ModalBox.js";
import $ from "../../temp-lib/components/share/next/Image.js";
import { useMessageContext as R } from "../../temp-lib/contexts/share/MessageContext.js";
import { noForwardCustomProps as V, noForwardProps as W } from "../../temp-lib/util/styled/index.js";
import * as i from "ramda";
import { useState as q, useCallback as p, useEffect as y } from "react";
import { Trans as T } from "react-i18next";
import { jsxs as u, jsx as e, Fragment as J } from "react/jsx-runtime";
const K = o(G)`
  align-items: center;
  background: linear-gradient(180deg, #1b2327 0%, #2c3031 100%);
  box-shadow: 0px 0px 10px #000000;
  display: flex;
  flex-direction: column;
  left: 50%;
  max-width: 600px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 95%;

  ${(t) => t.theme.breakpoints.up("res1024")} {
    border-radius: 10px;
  }
  ${(t) => t.theme.breakpoints.down("res1024")} {
    border-radius: 5px;
  }
`, L = o(l)`
  height: 50px;
  position: absolute;
  top: 0px;
  width: 100%;
`, O = o(l, V(["containHeader"]))`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  min-height: 100px;
  padding: 40px 20px;
  width: 100%;
  ${(t) => t.theme.breakpoints.up("res1024")} {
    ${(t) => t.containHeader && "padding-bottom: 40px;"}
  }
`, Q = o(E)`
  float: right;
  height: 100%;
  aspect-ratio: 1;
  padding: 15px 5px;
`, U = o($)`
  height: 100%;
  aspect-ratio: 1;
`, X = o($)`
  width: 120px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`, Y = o(A)`
  color: white;
  font-family: Arial;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;

  strong {
    color: rgb(245, 194, 66);
  }
`, Z = o(l)`
  color: rgba(177, 179, 179, 1);
  font-weight: 400;
  max-height: 500px;
  overflow: auto;
  text-align: center;
  white-space: pre-wrap;
  width: 100%;

  ${(t) => t.theme.breakpoints.up("res1024")} {
    font-size: 16px;
    line-height: 22px;
  }
  ${(t) => t.theme.breakpoints.down("res1024")} {
    font-size: 14px;
    line-height: 18px;
  }

  strong {
    color: rgb(245, 194, 66);
    font-weight: 500;
  }
`, tt = o(A)`
  background: #1c1c1a;
  border-radius: 2px;
  color: #b0b2b2;
  font-family: Arial;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  padding: 4px 8px;
`, ot = o(l, W)`
  display: flex;
  width: 100%;
  max-width: 380px;

  ${(t) => t.theme.breakpoints.up("res480")} {
    flex-direction: row-reverse;
    justify-content: ${(t) => t.__hasTwoButtons ? "space-between" : "center"};
  }
  ${(t) => t.theme.breakpoints.down("res480")} {
    flex-direction: column;
    gap: 8px;
  }
`, M = o(D)`
  padding: 6px 25px;
  min-width: 125px;
  height: 36px;
`, et = o(M)`
  --background-color: #1d66bf;
`, nt = o(M)`
  --background-color: transparent;
  border: 1px solid #1d66bfaa;
  padding: 5px 24px;
`, ut = (t) => {
  const {
    className: j
  } = t, {
    info: r,
    cleanInfo: f
  } = R(), [x, g] = q(r), {
    cancel: a,
    confirm: c,
    crossButton: b,
    icon: w,
    message: C,
    skipTouch: N,
    tag: B,
    timeout: d,
    title: k,
    onClose: m,
    onConfirm: h,
    onCancel: s
  } = x || {}, H = c || a, I = !i.isNil(r), P = i.isNotNil(a) && i.isNotNil(c), z = p(() => {
    g(null);
  }, []), n = p(() => {
    m && m(), f();
  }, [m, f]), F = p(() => {
    if (i.isNil(h)) {
      n == null || n();
      return;
    }
    h();
  }, [n, h]), _ = p(() => {
    if (i.isNil(s)) {
      n == null || n();
      return;
    }
    s == null || s();
  }, [n, s]);
  return y(() => {
    if (!i.isNil(d)) {
      const v = setTimeout(() => {
        n();
      }, d);
      return () => clearTimeout(v);
    }
  }, [r, d, n]), y(() => {
    r && g(r);
  }, [x, r]), /* @__PURE__ */ u(K, {
    className: j,
    closeAfterTransition: !0,
    disableAutoFocus: !0,
    hideBackdrop: N,
    open: I,
    onClose: z,
    slotProps: {
      root: {
        style: {
          pointerEvents: N ? "none" : "inherit"
        }
      }
    },
    children: [b ? /* @__PURE__ */ e(L, {
      className: "Custom-Header",
      children: /* @__PURE__ */ e(Q, {
        onClick: n,
        children: /* @__PURE__ */ e(U, {
          src: S
        })
      })
    }) : /* @__PURE__ */ e(J, {}), /* @__PURE__ */ u(O, {
      className: "Custom-Container",
      containHeader: !!b,
      children: [w && /* @__PURE__ */ e(X, {
        src: w
      }), k && /* @__PURE__ */ e(Y, {
        className: "Custom-Title",
        children: /* @__PURE__ */ e(T, {
          children: k
        })
      }), C && /* @__PURE__ */ e(Z, {
        className: "Custom-Message",
        children: /* @__PURE__ */ e(T, {
          children: C
        })
      }), B && /* @__PURE__ */ e(tt, {
        noWrap: !0,
        children: B
      }), H && /* @__PURE__ */ u(ot, {
        __hasTwoButtons: P,
        className: "Custom-Button-Container",
        children: [i.isNotNil(c) && /* @__PURE__ */ e(et, {
          className: "Custom-Confirm-Button",
          onClick: F,
          children: c
        }), i.isNotNil(a) && /* @__PURE__ */ e(nt, {
          className: "Custom-Cancel-Button",
          onClick: _,
          children: a
        })]
      })]
    })]
  });
};
export {
  ut as default
};
//# sourceMappingURL=ApeironMessagePopup.js.map
